import './HeroSection.css';

export default function HeroSection() {
    return (
        <section className="hero">
            <div className="hero-bg-shape hero-shape-1"></div>
            <div className="hero-bg-shape hero-shape-2"></div>

            <div className="hero-dark-layer"></div>

            <div className="hero-content">
                <p className="hero-badge">Rénovation intérieure et extérieur • Finitions soignées</p>

                <h1 className="hero-title">
                    Donnez une nouvelle vie à vos espaces avec
                    <span> Kyra Renov</span>
                </h1>

                <p className="hero-subtitle">
                    Spécialistes de la rénovation intérieure et extérieur, nous transformons vos
                    appartements, maisons et espaces de vie avec un travail précis,
                    moderne et durable.
                </p>

                <div className="hero-actions">
                    <a href="#contact" className="hero-button hero-button-primary">
                        Demander un devis
                    </a>

                    <a href="#services" className="hero-button hero-button-secondary">
                        Découvrir nos services
                    </a>
                </div>

                <div className="hero-highlights">
                    <div className="hero-highlight-card">
                        <h3>Travail soigné</h3>
                        <p>Des finitions propres et un rendu professionnel.</p>
                    </div>

                    <div className="hero-highlight-card">
                        <h3>Accompagnement</h3>
                        <p>Des conseils adaptés à votre projet et à votre budget.</p>
                    </div>

                    <div className="hero-highlight-card">
                        <h3>Réactivité</h3>
                        <p>Une entreprise disponible pour avancer efficacement.</p>
                    </div>
                </div>
            </div>
        </section>
    );
}